import React, { PropsWithChildren } from 'react'
import Badge, { BadgeSize } from './Badge'
import { SaleBadgeContainer, SaleBadgeLabel } from './styled'

const SaleBadge: React.FC<PropsWithChildren<{ className?: string; size: BadgeSize }>> = ({
  children,
  className,
  size,
}) => (
  <SaleBadgeContainer className={className}>
    <Badge size={size} />
    <SaleBadgeLabel>{children}</SaleBadgeLabel>
  </SaleBadgeContainer>
)

export default SaleBadge

export { BadgeSize }
